import { Button } from "@/components/ui/button";
import { MonitorSmartphone, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

const DESKTOP_ONBOARDING_URL = "https://app.yachtbooks.io/onboarding";

export default function OnboardingRequired() {
  const { t } = useTranslation();

  return (
    <>
      <title>{t("title.onboarding_required")}</title>

      <div className="px-4 py-6">
        <div className="mx-auto max-w-xl rounded-xl border border-[#38628f]/60 bg-[#09213e]/90 p-6 text-white shadow-lg">
          <div className="mb-4 flex items-center gap-3 text-[#8ec5ff]">
            <MonitorSmartphone className="h-6 w-6" />
            <h1 className="text-lg font-semibold">
              {t("onboarding_required.title")}
            </h1>
          </div>

          <p className="mb-3 text-sm leading-6 text-[#d5e6ff]">
            {t("onboarding_required.subtitle")}
          </p>
          <p className="mb-6 text-sm leading-6 text-[#b7d2f4]">
            {t("onboarding_required.description")}
          </p>

          <div className="flex flex-col gap-3">
            <Button
              type="button"
              className="w-full"
              onClick={() =>
                window.open(
                  DESKTOP_ONBOARDING_URL,
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              {t("onboarding_required.open_desktop")}
            </Button>

            <Button
              type="button"
              variant="outline"
              className="w-full border-[#4d7fb3] text-[#d5e6ff] hover:bg-[#14365d]"
              onClick={() => window.location.reload()}
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              {t("onboarding_required.refresh_status")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
